// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"67a63864","498":"9036f97e","513":"c307562f","703":"94bc99d6"}[chunkId] + ".chunk.js";
};